"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9789],{

/***/ 9789:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var dayjs_locale_th__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62019);
/* harmony import */ var dayjs_locale_th__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(dayjs_locale_th__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var dayjs_plugin_buddhistEra__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40683);
/* harmony import */ var dayjs_plugin_buddhistEra__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_buddhistEra__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var numeral__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92077);
/* harmony import */ var numeral__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(numeral__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67294);
/* harmony import */ var react_icons_ai__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(87771);
/* harmony import */ var react_icons_ri__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(7696);
/* harmony import */ var src_components_image__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(84334);
/* harmony import */ var src_constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(15072);
/* harmony import */ var src_utils_datalayer_send_datalayer__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(34892);
/* harmony import */ var src_utils_helper__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(39334);
/* harmony import */ var src_utils_increment_countview__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(20464);














dayjs__WEBPACK_IMPORTED_MODULE_1___default().extend((dayjs_plugin_buddhistEra__WEBPACK_IMPORTED_MODULE_3___default()));
var CardH = function(param) {
    var data = param.data, _large = param.large, large = _large === void 0 ? false : _large, _description = param.description, description = _description === void 0 ? false : _description, _withMB = param.withMB, withMB = _withMB === void 0 ? null : _withMB, _txtStyle = param.txtStyle, txtStyle = _txtStyle === void 0 ? false : _txtStyle, _external = param.external, external = _external === void 0 ? false : _external, _eyeBall = param.eyeBall, eyeBall = _eyeBall === void 0 ? true : _eyeBall, eventDataLayer = param.eventDataLayer, heading = param.heading, _showFooter = param.showFooter, showFooter = _showFooter === void 0 ? true : _showFooter, _isVideo = param.isVideo, isVideo = _isVideo === void 0 ? false : _isVideo, _showReadmore = param.showReadmore, showReadmore = _showReadmore === void 0 ? false : _showReadmore, _isH3 = param.isH3, isH3 = _isH3 === void 0 ? true : _isH3, _showBlurb = param.showBlurb, showBlurb = _showBlurb === void 0 ? false : _showBlurb, _showBadge = param.showBadge, showBadge = _showBadge === void 0 ? false : _showBadge, _loading = param.loading, loading = _loading === void 0 ? "lazy" : _loading;
    var ref, ref1, ref2, ref3;
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(0), countView = ref4[0], setCountView = ref4[1];
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(function() {
        (0,src_utils_increment_countview__WEBPACK_IMPORTED_MODULE_10__/* .incrementCountview */ .x)(data).then(function(item) {
            return setCountView(item);
        }).catch(function() {
            return setCountView(0);
        });
    }, []);
    var categoryNameTH = (data === null || data === void 0 ? void 0 : (ref = data.subCategory) === null || ref === void 0 ? void 0 : ref.th) ? data === null || data === void 0 ? void 0 : (ref1 = data.subCategory) === null || ref1 === void 0 ? void 0 : ref1.th : data === null || data === void 0 ? void 0 : (ref2 = data.section) === null || ref2 === void 0 ? void 0 : ref2.th;
    var dateUpdate = dayjs__WEBPACK_IMPORTED_MODULE_1___default()(data === null || data === void 0 ? void 0 : data.published_at).locale("th").format("DD MMM BBBB | H:mm");
    var conditionBadge = showBadge && (0,src_utils_helper__WEBPACK_IMPORTED_MODULE_9__/* .convertBadge */ .lC)(data, false);
    // console.log(data);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: external ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            href: data === null || data === void 0 ? void 0 : data.link,
            //! DATALAYER
            target: "_blank",
            rel: "noopener noreferrer",
            className: "card-wrapper",
            onClick: function() {
                return (0,src_utils_datalayer_send_datalayer__WEBPACK_IMPORTED_MODULE_8__/* .sendDataLayerGlobal */ .dE)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, eventDataLayer));
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "card-h ".concat(withMB === null ? "" : withMB),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "card-h-thumb ".concat(large ? "--large" : ""),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_image__WEBPACK_IMPORTED_MODULE_6__["default"], {
                                image: data === null || data === void 0 ? void 0 : data.image,
                                title: data === null || data === void 0 ? void 0 : data.title,
                                external: external,
                                type: large ? "CARD_MEDIUM" : "CARD_SMALL",
                                loading: loading
                            }),
                            isVideo && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "icon",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_ri__WEBPACK_IMPORTED_MODULE_12__/* .RiPlayCircleLine */ .YEk, {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "card-h-content ".concat(large ? "--large" : ""),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                className: "card-h-content-title ".concat(txtStyle ? "--light" : "", " text-excerpt-2"),
                                children: data === null || data === void 0 ? void 0 : data.title
                            }),
                            showReadmore && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "read-more",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    children: "อ่านต่อ..."
                                })
                            }),
                            showFooter && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "card-h-content-meta ".concat(txtStyle ? "--small" : ""),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_ai__WEBPACK_IMPORTED_MODULE_13__/* .AiOutlineClockCircle */ .cjn, {}),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        children: dateUpdate
                                    })
                                ]
                            }),
                            description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "text-excerpt-3",
                                children: data === null || data === void 0 ? void 0 : data.blurb
                            })
                        ]
                    })
                ]
            })
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            href: data === null || data === void 0 ? void 0 : data.link,
            className: "card-wrapper",
            //! DATALAYER
            onClick: function() {
                return (0,src_utils_datalayer_send_datalayer__WEBPACK_IMPORTED_MODULE_8__/* .sendDataLayerGlobal */ .dE)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, eventDataLayer));
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "card-h ".concat(withMB === null ? "" : withMB),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "card-h-thumb ".concat(large ? "--large" : ""),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_image__WEBPACK_IMPORTED_MODULE_6__["default"], {
                                image: data === null || data === void 0 ? void 0 : data.image,
                                title: data === null || data === void 0 ? void 0 : data.title,
                                type: large ? "CARD_MEDIUM" : "CARD_SMALL",
                                loading: loading
                            }),
                            (data === null || data === void 0 ? void 0 : (ref3 = data.section) === null || ref3 === void 0 ? void 0 : ref3.th) !== null && large && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "badge",
                                children: categoryNameTH
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "card-h-content ".concat(large ? "--large" : ""),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                className: "card-h-content-title ".concat(txtStyle ? "--light" : "", " text-excerpt-2"),
                                children: data === null || data === void 0 ? void 0 : data.title
                            }),
                            showBlurb && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "card-h-content-blurb ".concat(txtStyle ? "--light" : "", " text-excerpt-2"),
                                children: data === null || data === void 0 ? void 0 : data.blurb
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "card-h-content-meta ".concat(txtStyle ? "--small" : ""),
                                children: [
                                    conditionBadge && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "meta-badge",
                                        children: conditionBadge
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_ai__WEBPACK_IMPORTED_MODULE_13__/* .AiOutlineClockCircle */ .cjn, {}),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "date",
                                        children: dateUpdate
                                    }),
                                    eyeBall && countView > 0 && countView > Number(src_constants__WEBPACK_IMPORTED_MODULE_7__/* .NEXT_PUBLIC_DEFAULT_COUNT_VIEW */ .d$) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                        className: "pageview",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_ai__WEBPACK_IMPORTED_MODULE_13__/* .AiOutlineEye */ .Zju, {}),
                                            countView > 999 ? numeral__WEBPACK_IMPORTED_MODULE_4___default()(countView).format("0.0a") : countView
                                        ]
                                    })
                                ]
                            }),
                            description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "text-excerpt-3",
                                children: data === null || data === void 0 ? void 0 : data.blurb
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (CardH);


/***/ })

}]);